<app-loading [show]="load"></app-loading>
<div id="divIni" class="p-fluid pt-0 p-2">
    <div class="text-center">
        <img src="assets/img/logoSimescco.jpg" class="logo">
    </div>
    <div class="text-center">
        <h3>Ticket {{lsInfo[0]?.idVenta}}</h3>
    </div>
    <div class="mx-auto p-5 md:w-5 w-full" *ngIf="(this.lsInfoIntegration?.stamp?.cufe??'') !=''">
        <p>Factura: {{this.lsInfoIntegration?.name}}</p>
        <div class="text-center">
            <p class=" text-xs" style="text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;">CUFE: {{this.lsInfoIntegration?.stamp?.cufe}}</p>
            <qr-code value="{{this.lsInfoIntegration?.stamp?.cufe}}" size="120" errorCorrectionLevel="M" />
        </div>
        <button pButton label="Descargar Factura" icon="pi pi-check-circle" (click)="download()"></button>
    </div>
    <div *ngIf="(lsInfoIntegration?.stamp?.cufe ??'') ==''">
        Factura en proceso, favor consulte en 10 mínutos
    </div>
    <span [innerHTML]="msgError"></span>
</div>